import React from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { unsetDialog } from './store/actions/dialog'
import store from './store'
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@material-ui/core'
import ScrollToTop from './ScrollToTop'
import DefaultLayout from './layouts/DefaultLayout'
import AuthLayout from './layouts/AuthLayout'
import PageNotFound from './pages/PageNotFound'
import { Admin } from './types/Admin'
import { unsetAuth } from './store/actions/auth'

const App: React.FC<ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>> = ({
  token,
  admin,
  unsetAuth,
  dialog,
  unsetDialog
}) => {
  const loginAuth = async () => {
    try {
      const { data } = await axios.post<{
        token: string
        admin: Admin
        message: string
      }>(`/auth/admin/login`, {
        admin_id: admin.adminId,
        password: admin.password
      })
      return true
    } catch (error) {
      unsetAuth()
      return false
    }
  }

  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route path="/auth" component={AuthLayout} />
          <Route path="/page-not-found" component={PageNotFound} />
          {token && loginAuth() ? (
            <Route path="/" component={DefaultLayout} />
          ) : (
            <Redirect to={'/auth/login'} />
          )}
        </Switch>
      </ScrollToTop>
      <Dialog
        open={dialog.isShow}
        onClose={unsetDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{dialog.content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {!dialog.noCancel && (
            <Button
              onClick={() => {
                dialog.ngHandler()
                unsetDialog()
              }}
              color="primary"
            >
              キャンセル
            </Button>
          )}
          <Button
            onClick={() => {
              dialog.okHandler()
              unsetDialog()
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Router>
  )
}

const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  // 上のApp変数のpropsに下のreturn
  // で返ってくるオブジェクトが入る
  return {
    token: state.auth.token,
    admin: state.auth,
    dialog: state.dialog
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    unsetAuth: () => dispatch(unsetAuth()),
    unsetDialog: () => dispatch(unsetDialog())
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App)
